/* Dansk katalog for locale-autopilot-sales.js.
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('da', {
  'ap.agent.sales.title': 'Fakturaer og tilbud',
  'ap.agent.sales.pending': '{{count}} dokumenter er ikke sendt.',
  'ap.agent.sales.detail': 'Send færdige fakturaer og tilbud. Kladder skal færdiggøres i fakturalisten.',
  'ap.agent.sales.draft': 'Kladde',
  'ap.agent.sales.invoices': 'Fakturaer',
  'ap.agent.sales.drafts': 'Kladder',
  'ap.agent.sales.offers': 'Tilbud',
  'ap.agent.offer.sendSelected': 'Send {{count}} valgte tilbud',
  'ap.agent.sales.sentCount': '{{count}} tilbud sendt',
  'ap.agent.sales.send': 'Send',
  'ap.agent.sales.open': 'Åbn',
  'ap.agent.sales.empty': 'Ingen usendte dokumenter i denne liste.',
  'ap.agent.sales.unavailable': 'Dokumentet kan ikke sendes. Åbn fakturalisten for at kontrollere status.',
  'ap.agent.sales.emailMissing': 'Kunden mangler en e-mailadresse. Tilføj den i fakturalisten før afsendelse.',
  'ap.agent.sales.sendFailed': 'Dokumentet blev ikke sendt. Prøv igen fra fakturalisten.',
});
